import "./LandingHero.css";
import { Badge, Button, Flex, Grid, Group, Loader, Modal } from "@mantine/core";
import { IconArrowRight, IconCheck, IconExternalLink, IconPlayerPlay, IconUsers } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function LandingHero() {
   return (
      <div className="landingHero__container">
         <Grid pb={100} py={30} w='100%'>
            <Grid.Col span={{ base: 12, md: 6 }}>
               <div className="landingHero__column">
                  <h1 className="landingHero__title">
                     Te acompañamos. <br />
                     <strong>Pensamos juntos.</strong>
                  </h1>

                  <div className="landingHero__block">
                     <p className="landingHero__text">
                        FORVET es la comunidad donde veterinarios de Latinoamérica construyen criterio clínico colectivo a través de mentoría horizontal, debate de casos reales y datos de nuestra región. </p>
                  </div>
                  {/* <SearchBanner /> */}

                  <Flex gap={16} w='100%' justify='start'>
                     <Button rightSection={<IconArrowRight size={16} />} component="a" href='#programas'>
                        Ver programas
                     </Button>
                     <Button variant="outline" color="var(--color-text-primary)" leftSection={<IconUsers size={16} />} component="a" href='#que-esta-pasando'>
                        Ver comunidad
                     </Button>
                  </Flex>
                  <Flex gap={16} w='100%' justify='start'>
                     <HeroCounter />
                  </Flex>
               </div>
            </Grid.Col>
            <HeroEventsCatalog />
         </Grid>
      </div >
   );
}

export default LandingHero;


const HeroEventsCatalog = () => {
   const [state, setState] = useState({
      isLoading: false,
      error: false,
      data: null
   });

   // Estado para controlar el modal
   const [opened, setOpened] = useState(false);

   useEffect(() => {
      const getData = async () => {
         try {
            setState(prev => ({ ...prev, isLoading: true }));
            const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/events?active=true&students=true`;
            const { data } = await axios.get(URL);
            setState(prev => ({ ...prev, data, isLoading: false }));
         } catch (error) {
            console.log(error);
            setState(prev => ({ ...prev, error: true, isLoading: false }));
         }
      };
      getData();
   }, []);

   if (state.isLoading) {
      return (
         <Grid.Col span={{ base: 12, md: 6 }}>
            <Flex w="100%" justify="center" align="center" h="100%">
               <Loader size="xl" />
            </Flex>
         </Grid.Col>
      );
   }

   if (state.error || !state.data) return null;

   const {
      thumbnail, title, external_url, video_url,
      tags, subheading, caption, date, _id: eventId, new_students
   } = state.data;

   const backgroundCardThumnailSyles = thumbnail ? {
      backgroundImage: `url(${thumbnail})`,
      backgroundSize: 'cover',
   } : {};

   const trackAction = async (id) => {
      try {
         const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/events/view`;
         await axios.patch(URL, { eventId: id });
      } catch (error) {
         console.log('Error al registrar acción:', error);
      }
   };

   const handleMainClick = () => {
      trackAction(eventId); // Contabilizamos la view siempre

      if (video_url) {
         setOpened(true);
      } else {
         window.open(external_url, '_blank');
      }
   };

   return (
      <Grid.Col span={{ base: 12, md: 6 }}>
         <div className="hero-visual">
            <div className="video-preview">
               <div
                  onClick={handleMainClick}
                  className="video-preview-bg"
                  style={{ ...backgroundCardThumnailSyles, cursor: 'pointer' }}
               >
                  {subheading && <div className="video-tag">{subheading}</div>}
                  <div className="play-btn">
                     {video_url ? <IconPlayerPlay /> : <IconExternalLink />}
                  </div>
                  {caption && <div className="video-label">{caption}</div>}
               </div>
            </div>

            {/* Modal para el Video */}
            <Modal
               opened={opened}
               onClose={() => setOpened(false)}
               title={title}
               styles={{title: {
                  fontSize: "16px"
               }}}
               size="xl"
               centered
            >
               <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                  <iframe
                     src={video_url}
                     style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                     frameBorder="0"
                     allowFullScreen
                  />
               </div>

               <Group justify="apart" mt="md">
                  <Button variant="light" color="gray" onClick={() => setOpened(false)}>
                     Cerrar
                  </Button>
                  <Button
                     rightSection={<IconExternalLink size={16} />}
                     onClick={() => window.open(external_url, '_blank')}
                  >
                     Ver más información
                  </Button>
               </Group>
            </Modal>

            <div className="floating-card card-1">
               <div className="fc-icon green"><IconCheck /></div>
               <div>
                  {title && <div className="fc-text-main">{title}</div>}
                  <div className="fc-text-sub">
                     {new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} hrs —
                     {tags?.map((tag, idx) => (
                        <span key={idx}>{`${tag}${(idx + 1) < tags.length ? ", " : ""}`}</span>
                     ))}
                  </div>
               </div>
            </div>

            {new_students && (
               <div className="floating-card card-2">
                  <div>
                     <div className="fc-text-main">+{new_students} veterinarios</div>
                     <div className="fc-text-sub">se unieron este mes</div>
                  </div>
               </div>
            )}
         </div>
      </Grid.Col>
   );
};


const HeroCounter = () => {


   const [state, setState] = useState({
      isLoading: false,
      error: false,
      data: null
   })

   useEffect(() => {
      const getData = async () => {
         try {
            setState(prev => ({ ...prev, isLoading: true }))
            // Simulación de delay de red
            const URL = `${process.env.REACT_APP_BACKEND_SERVER}/info/getHomeLandingStats?is_student=true&is_country=true&is_pathology=true`
            const { data } = await axios.get(URL)
            setState(prev => ({ ...prev, data }))
         } catch (error) {
            console.log(error)
            setState(prev => ({ ...prev, error: true }))

         } finally {
            setState(prev => ({ ...prev, isLoading: false }))
         }
      }
      getData()
   }, [])

   if (state.isLoading) {
      return <Grid.Col span={{ base: 12, md: 6 }}>
         <Flex w='100%' justify='center' align='center' h='100%'>
            <Loader />
         </Flex>
      </Grid.Col>
   }

   if (state.error) return <></>


   const counter = state?.data?.counter


   return (
      <div className="hero-stats">

         {counter && counter?.map((item, idx) => (
            <div className="hero-stat" key={idx}>
               <div className="hero-stat-number">{item.count}</div>
               <div className="hero-stat-label">{item.label}</div>
            </div>
         ))}
      </div>
   )
}